<div class="cellWrapper centered">
    @if (hasTooltip()) {
        <span
            class="hasTooltip"
            appTooltip
            [component]="tooltipComponent()"
            [componentData]="tooltipData()"
            [position]="tooltipPosition()"
            [trigger]="tooltipTrigger()"
        >
            <ng-container *ngTemplateOutlet="dateContent"></ng-container>
        </span>
    } @else {
        <ng-container *ngTemplateOutlet="dateContent"></ng-container>
    }

    <ng-template #dateContent>
        @if (useCustomFormat()) {
            {{ displayValue() | translate }}
        } @else {
            {{ date | date: format : timezone }}
        }
    </ng-template>
</div>
